import React from 'react';
import { goBack } from '../../../routing/redirectService';
import './BackButton.scss';
import TransparentButton from '../transparent-button/TransparentButton';

export const BackButton = ({ onBackButtonClicked }) => {
    const routeBack = () => {
        onBackButtonClicked && onBackButtonClicked();
        goBack();
    };

    return (
        <TransparentButton disableRipple onClick={routeBack}>
            <i className="material-icons">keyboard_arrow_left</i>
            Back
        </TransparentButton>
    );
};
